module.exports = __webpack_public_path__ + "static/media/search.2bb2e727.png";